import { authServiceAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { authAPIUrls } from '../data';
import { Products } from '../types';

type Return = {
  message: string;
  data: Products;
};

export type GetProducts = {
  return: Return;
};

export const getProducts = withLogger(async (): Promise<Products> => {
  const {
    data: { data },
  } = await authServiceAxiosClient.get<GetProducts['return']>(
    authAPIUrls.subscriptionProducts,
  );

  return data;
});
